export enum MESSAGES {
    SAVED = 'Successfully saved.',
    COPIED = 'Successfully copied.',
    CREATED = 'Successfully created.',
    DELETED = 'Successfully deleted.',
    UNKNOWN_ERROR = 'Unknown error occurred.',
    DATA_LOADING_ERROR = 'Oops, data loading problem ...'
}
